import React from 'react';
import wave from '../../assets/images/wave.svg';

import { Wrapper } from './Wave.styles';

const Wave = () => <Wrapper background={wave} />;

export default Wave;
